import React from "react";
import {
  ContentWithImage,
  Headline,
  Link,
  SectionContent,
  Text,
} from "../../../../components";
import * as S from "./UsarAssistencia.Style";
import AssistenciaImg from "../../../../assets/images/habitacional/ilustracao-homem-segurando-celular.svg";

const UsarAssistencia = () => {
  return (
    <>
      <SectionContent>
        <ContentWithImage
          imgSrc={AssistenciaImg}
          imgAlt="Homem segurando celular"
          imgColumnSize="4"
        >
          <Headline nivel="2" styleAs="5">
            <strong>Quer usar sua assistência?</strong>
          </Headline>
          <S.BodyContent>
            <S.ImgMobile src={AssistenciaImg} alt="Homem com celular" />
            <div>
              <S.TextDescription as={Text} textSize="lg">
                Ligue para a{" "}
                <strong>Assistência Dia & Noite e Sinistros</strong>
                <br />
                <S.Link as={Link} textSize="xl" href="tel:08002741000">
                  0800 274 1000
                </S.Link>
              </S.TextDescription>
            </div>
          </S.BodyContent>
        </ContentWithImage>
      </SectionContent>
    </>
  );
};

export default UsarAssistencia;
